import styled from "styled-components";
export const Picker = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const PickerContainer = styled.div`
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 20px;
`;
export const PickerTop = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 14px;
  opacity: 0.5;
  height: 20%;
`;
export const PickerMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 18px;
  border-bottom: 2px solid #f6f7f9;
  border-top: 2px solid #f6f7f9;
  padding: 5px;
  margin: 5px;
`;
export const PickerBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 14px;
  opacity: 0.5;
  height: 20%;
`;
